import type SignalFilters from "../core/SignalFilters";

export enum SignalTimeframePeriod {
    Day = "Day",
    Week = "Week",
    Month = "Month",
    Year = "Year",
}

export type SignalTimeframe = {
    readonly amount: number;
    readonly id: string;
};

export interface SignalTimeframeConfig<F extends SignalFilters> {
    readonly options: readonly SignalTimeframe[];
    fromFilters(filters: Partial<F>): SignalTimeframe | undefined;
    toFilters(timeframe: SignalTimeframe): Partial<F>;
}
